import React from "react";
import { useParams } from "react-router-dom";
import useDeletedNodeData from "./useDeletedNodeData";
import PreviewCommonComponent from "../MoveAction/PreviewAndReview/Preview/Components/PreviewCommonComponent";

const PreviewDeletedNode = () => {
  const { audit_trail_id } = useParams();

  const previewData = useDeletedNodeData(audit_trail_id);

  if (previewData.loading || previewData.snapshotLoading) return <div>Loading...</div>;
  if (previewData.error || previewData.snapshotError) return <div>Error: {previewData.error || previewData.snapshotError}</div>;

  return <>
    <PreviewCommonComponent previewData={previewData} audit_trail_id={audit_trail_id} />
  </>
};

export default PreviewDeletedNode;